<!-- Copyright Form -->
@if (copyrightForm) {
  <medsurf-design-form-control-form
    [formGroup]="copyrightForm"
    (onSubmit)="onSubmit()">
    <div class="flex flex-column gap-2">
      <!-- Copyright -->
      @if (constantAuthorFacade.copyrightArray$ | async; as copyrightArray) {
        <medsurf-design-form-control-input-dropdown
          [formField]="false"
          [control]="copyrightForm.controls.id"
          [filter]="true"
          [class]="'overflow-auto w-full align-self-start'"
          [placeholder]="'global.copyright_add'"
          [options]="copyrightArray"
          (valueChange)="onSubmit()">
        </medsurf-design-form-control-input-dropdown>
      }
      <div medsurf-design-content-input-group class="gap-2">
        <!-- Text -->
        <medsurf-design-form-control-input-text
            [formField]="false"
            class="flex flex-1 min-w-5rem"
            [control]="copyrightForm.controls.text"
            [placeholder]="'global.text'"
            (valueChange)="onSubmit()"></medsurf-design-form-control-input-text>
        <!-- Remove Value -->
        <button medsurf-design-input-button [hidden]="copyrightForm.value.id === ''"
          [id]="'copyright_remove'"
          [title]="'global.copyright_remove' | translate"
          [iconClass]=FlatModels.ButtonDesignModels.ButtonDefaultIcons.REMOVE
        (click)="removeValue()"></button>
      </div>
    </div>
  </medsurf-design-form-control-form>
}